import { Icon } from "@kanda-libs/ks-design-library";
import type { FunctionComponent } from "react";
import { COMPANY_RISK_FLAG_STROKES } from "./constants";
import useCompanyRiskFlag from "./useCompanyRiskFlag";

export interface CompanyRiskFlagProps {
  id?: string;
  className?: string;
}

const CompanyRiskFlag: FunctionComponent<CompanyRiskFlagProps> = function ({
  id,
  className = "",
}) {
  const { level } = useCompanyRiskFlag(id);

  return (
    <Icon
      icon="flag"
      size={18}
      stroke={COMPANY_RISK_FLAG_STROKES[level as string]}
      className={className}
    />
  );
};

export default CompanyRiskFlag;
